import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { Text } from 'src/components/Text/Text'

export const MidInfoSection = () => (
  <Container columns="2" id="gift-subscription-info">
    <section>
      <Headline variant="h3">Darum ist das Geschenkabo so beliebt</Headline>
      <Text variant="p">
        Du eröffnest dem/der Beschenkten eine neue Kaffeewelt – perfekt für Kaffee-Neulinge und -Enthusiasten
        gleichermaßen. Er/Sie entdeckt monatlich die besten Kaffees der Ernte, für die unsere talentierten Röstmeister
        individuelle Röstprofile entwickeln. So stellen wir sicher, dass die feinen Nuancen eines jeden Kaffees
        besonders gut zur Geltung kommen.
      </Text>
    </section>
    <section>
      <Headline variant="h3">In 4 einfachen Schritten zur Kaffee-Überraschung:</Headline>
      <ol className="list">
        <li>Passendes Kaffee-Geschenkabo auswählen.</li>
        <li>Details der Empfänger:in und Versanddatum für den Gutschein festlegen.</li>
        <li>Geschenkzertifikat personalisieren und ausdrucken.</li>
        <li>Kaffee-Geschenkabo verschenken und Freude bereiten.</li>
      </ol>
    </section>
  </Container>
)
